module.exports = __webpack_public_path__ + "img/case64.056a6cdd.png";